import slideout from "../helpers/slideout";
import slider from "../helpers/slider";
import { TinySliderInstance } from "tiny-slider";
import lazyLoader from "./lazyLoader";

interface IMenuConfig {
  nodeLists: IMenuNodeLists,
  selectors: IMenuSelectors,
  htmlElements: IMenuHtmlElements,
  slideout: Slideout,
  slider: TinySliderInstance
}

interface IMenuHtmlElements {
  slider: HTMLElement
}

interface IMenuNodeLists{
  main: NodeList,
  open: NodeList,
  close: NodeList,
  submenusOpen: NodeList,
  submenus: NodeList,
  submenusBack: NodeList
}

interface IMenuSelectors {
  main: string,
  open: string,
  close: string,
  slider: string,
  submenuOpen: string,
  submenu: string,
  submenuBack: string
}


class Menu {

  private config: IMenuConfig;

  constructor() {
    this.config = {
      slideout: null,
      slider: null,
      htmlElements: {
        slider: null
      },
      nodeLists: {
        main: null,
        open: null,
        close: null,
        submenusOpen: null,
        submenus: null,
        submenusBack: null
      },
      selectors: {
        main: '[data-menu]',
        open: '[data-menu-open]',
        close: '[data-menu-close]',
        slider: '[data-menu-slider]',
        submenuOpen: '[data-submenu-open]',
        submenu: '[data-submenu]',
        submenuBack: '[data-submenu-back]'
      }
    }
  }

  public init() {
    this.load();
    this.addEventListeners();
  }

  public reinit() {
    this.init();
  }

  private addEventListeners() {
    this.config.nodeLists.open.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.open.bind(this)));
    this.config.nodeLists.close.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.close.bind(this)));
    this.config.nodeLists.submenusOpen.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.openSubmenu.bind(this)));
    this.config.nodeLists.submenusBack.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.backSubmenu.bind(this)));
    this.config.slider.events.on('transitionEnd', this.resetSubmenus.bind(this));
  }

  private load() {
    this.config.nodeLists.main = document.querySelectorAll(this.config.selectors.main);
    this.config.nodeLists.open = document.querySelectorAll(this.config.selectors.open);
    this.config.nodeLists.close = document.querySelectorAll(this.config.selectors.close);
    this.config.htmlElements.slider = document.querySelector(this.config.selectors.slider);
    this.config.nodeLists.submenus = document.querySelectorAll(this.config.selectors.submenu);
    this.config.nodeLists.submenusOpen = document.querySelectorAll(this.config.selectors.submenuOpen);
    this.config.nodeLists.submenusBack = document.querySelectorAll(this.config.selectors.submenuBack);
    this.config.slider = this.slider();
    this.update();
  }

  private update() {
    this.config.nodeLists.main.forEach((htmlElement : HTMLElement) => this.config.slideout = this.slideout(htmlElement));
  }

  private slider(): TinySliderInstance {
    return slider.init(this.config.htmlElements.slider, { items: 1, gutter: 0, loop: false, touch: false });
  }

  private slideout(htmlElement: HTMLElement) : Slideout {
    return slideout.init(htmlElement);
  }

  private openSubmenu(event: Event) {
    const target = event.target as HTMLElement;
    const submenuName = target.dataset.submenuOpen;
    let submenu: HTMLElement = null;
    if (submenuName) submenu = this.getSubmenu(submenuName);
    if (submenu) submenu.classList.remove('hide'), this.config.slider.goTo(2);
  }

  private backSubmenu(event: Event) {
    this.config.slider.goTo('first');
  }

  private resetSubmenus() {
    const sliderInfo = this.config.slider.getInfo();
    if (sliderInfo.index === 0) this.config.nodeLists.submenus.forEach((htmlElement: HTMLElement) => htmlElement.classList.add('hide'));
  }

  private getSubmenu(submenuName: string): HTMLElement {
    return Array.from(this.config.nodeLists.submenus).find((htmlElement: HTMLElement) => htmlElement.dataset.submenu === submenuName) as HTMLElement;
  }

  private open() {
    this.config.slideout.open();
    lazyLoader.update();
  }

  private close() {
    this.config.slideout.close();
  }
}

export default new Menu();